export const MinimumAlphanumericalValueRequrement = 8;
export const DisplayNameRegexPattern = /[a-zA-Z0-9]/g;

export const validateDisplayName = (value: string) => {
  const messages = [];
  const matches = value.match(DisplayNameRegexPattern) || [];

  if (matches?.length < MinimumAlphanumericalValueRequrement) {
    messages.push(
      `Display name must have atleast ${MinimumAlphanumericalValueRequrement} alphanumerical characters!`,
    );
  }

  return messages;
};
